<template>
	<div>
		<el-row v-if="questionnaireTypeContent.length === 0" class="no-questionnaire" type="flex" align="middle" justify="space-around">
			<el-col :span="1">
				<img src="./analysis/response/icon/no-questionnaire.png" height="40px">
			</el-col>
			<el-col :span="23">
				<span>No Questionnaires Available for Progress Report</span>
			</el-col>
		</el-row>
		<el-table
			v-else
			v-bind:data="questionnaireTypeContent"
			:show-header="false"
			row-key="id"
			@row-click="expandRow"
			class="questionnaire-table"
			:expand-row-keys="expand"
			:cell-class-name="getCellClass"
			:row-class-name="getRowClass"
			empty-text="No questionnaires answered yet"
			style="width: 100%">

			
			<el-table-column prop="title" width="auto">
				<template slot-scope="scope">
					<div>
						<div style="padding-left:20px;">
							<strong>
								{{ getContentKey('questionnaire', scope.row.id, 'display_name') || getContentKey('questionnaire', scope.row.id, 'title') }}
							</strong>
						</div>
					</div>
				</template>
			</el-table-column>

			<el-table-column width="150">
				<template slot-scope="scope" v-if="scope.row.event.length">
					{{ getProviderNameById(scope.row.event[0].provider) }}
				</template>
			</el-table-column>

			<el-table-column width="50">
				<template slot-scope="scope" v-if="answered(scope.row)">
					<div style="margin-top: 10px;">
						<span v-if="expand.length && expand[0] === scope.row.id">
							<img src="../../images/up-arrow.png" width="21px" height="21px">
						</span>
						<span v-else>
							<img src="../../images/down-arrow.png" width="21px" height="21px">
						</span>
					</div>
				</template>
			</el-table-column>

			<el-table-column type="expand" width="1">
				<template slot-scope="scope">
					<ProgressAnalysis
						v-if="answered(scope.row)"
						v-bind:id="scope.row.id"
						v-bind:questionnaire="scope.row.event"
						v-bind:patient="patient">
					</ProgressAnalysis>
				</template>
			</el-table-column>

		</el-table>
	</div>

</template>
<script>
import CardTable from '../component/table'
import { mapState, mapGetters, mapActions } from 'vuex'

import QuestionnaireCalcMixin from '../mixin/questionnaire-calc'
import ProgressAnalysis from './analysis/Analysis'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import Icons from '../questionnaire/analysis/response/icon'
import content from '@/store/module/content'

export default {
	name: 'patient-questionnaire-card-table',
	extends: CardTable,

	mixins: [QuestionnaireCalcMixin],

	props: {
		patient: {
			type: Object,
			required: true
		},
		questionnaire: {
			type: Array
		},
		profileQuestionnairesId: {
			type: Array
		}
	},

	data() {
		return {
			edit: false,
			expand: [],
			progressReportingQuestions: [
				'slider', 
				'star', 
				'radio', 
				'scroller', 
				'unit', 
				'select', 
				'large_image_select', 
				'small_image_select',
				'box_select',
				'long_text_bubble',
				'binary'
			]
		}
	},

	methods: {
		openLinkDirectly(obj) {
			if (obj.hasOwnProperty('short_url'))
				window.open(obj.short_url, '_blank')
		},
		openLink(row) {
			window.open(this.incompleteLink(row), '_blank')
		}
	},

	computed: {
		...mapGetters('provider', [
			'getSurveyState'
		]),
		...mapGetters(['getUserType']),
		questionnaireType() {
			return this.typeMap(this.questionnaire)
		},
		questionnaireTypeContent() {
			let questContent = JSON.parse(JSON.stringify(this.questionnaireType)).map((type) => ({
				...type,
				content: this.getContent('questionnaire', type.id)
			}))
			let sqsAndBoqs = []

			questContent.forEach(q => {
					// Get sub questionnaires
					sqsAndBoqs.push(q.content.question.filter(qq => qq.type === 'questionnaire' && qq.hasOwnProperty('questionnaire')).map(qq => this.getContent('questionnaire', qq.questionnaire)))

					// Get Branch Out questionnaires
					q.content.question.filter(qq => qq.hasOwnProperty('branch_out') && Object.keys(qq.branch_out).length)
									.forEach(qq => Object.keys(qq.branch_out).forEach(k => {
											if (qq.branch_out[k]) 
												sqsAndBoqs.push(this.getContent('questionnaire', qq.branch_out[k]))
										}
									))

			})
			
			sqsAndBoqs = sqsAndBoqs.flatMap(q => q).map(q => {
				let reqObj = { content: q, id: q.questionnaire || q.id }
				return reqObj
			})

			// Remove sub questionnaires which do have any 
			// progress reporting questions or is disabled

			// iterate sqsAndBoqs
			// iterate through SQ/BOQ questions
			// if none of them have progress reporting enabled
			// or not applicable
			// remove that SQ/BOQ from the sqsAndBoqs
			sqsAndBoqs = sqsAndBoqs.filter(q => {
				let found = false

				q.content.question.forEach(qq => {
					if ((qq.hasOwnProperty('progress_reporting') && qq.progress_reporting) && (this.progressReportingQuestions.includes(qq.type)))
						found = true
						
				})
				return found
			})


			sqsAndBoqs.forEach(q => {
				if (!q.hasOwnProperty('event')) q.event = []
				questContent.forEach(qc => {
					qc.event.forEach(e => {
						e.question.filter(eq => eq.hasOwnProperty('questionnaire') && q.content.id === eq.questionnaire[0].type.split(':')[1])
								.forEach(f => {
									let reqObj = f.questionnaire[0]
									reqObj.completed = e.completed
									reqObj.provider = e.provider
									q.event.push(reqObj)
								})
					})
				})
			})
			questContent = questContent.filter(q => q.content && q.content.question)
				.filter(q => {
					let found = false
					q.content.question.forEach(quest => {
						if (quest.hasOwnProperty('progress_reporting') && quest.progress_reporting)
							found = true
					})
					return found
				})

			let finalContent = [...sqsAndBoqs, ...questContent]
			

			// remove empty events
			finalContent = finalContent.filter(qc => qc.event.length)
				.filter(qc => {
					let hasAnswer = false
					qc.event.forEach(qc_ev => {
						if (qc_ev.hasOwnProperty('question') && qc_ev.question.length)
							hasAnswer = true
					})
					return hasAnswer
				})
			

			// Remove duplicates
			let mapper = {}
			finalContent.forEach(qc => mapper[qc.id] = qc)
			finalContent = []
			Object.keys(mapper).forEach(k => finalContent.push(mapper[k]))
			// sort
			finalContent = finalContent.sort((a, b) => (a.content.display_name || a.content.title).toLowerCase() < (b.content.display_name || b.content.title).toLowerCase() ? -1 : 1)

			return finalContent
		}
	},

	components: {
		ProgressAnalysis,
		LoadSpinner,
		...Icons
	}
}
</script>

<style lang="scss">
.no-questionnaire {
	padding: 30px 20px;
	span {
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: #333333;
	}
}
.flag-image {
	width: 8px;
    height: 10px;
}
.flag-count {
	width: 36px;
	height: 20px;
	padding: 5px 8px;
	background: #FFEBEB;
	border-radius: 10px;
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
	text-align: center;
	color: #333333;
	margin-right: 10px;
}
.survey-icon {
	position: absolute;
	top: 50%;
	margin-top: -3%;
}
.not-answered-tag {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: #999999;
	background-color: #eeeeee;
	width: 84px;
    padding: 2px 5px;
}
.vital-icon {
	width: 40px;
	height: 40px;
	float: left;
}
.questionnaire-cell {
	cursor: pointer;
	.el-table__expand-icon {
		transform: rotate(90deg);
		height: 24px;
		width: 24px;
		border-radius: 50%;
		border: 1px solid #cccccc;
		color: #666666;
		font-weight: bold;
		.el-icon {
			font-weight: bold;
			margin-left: -6px;
		}
	}
	.el-table__expand-icon--expanded {
		transform: rotate(-90deg);
		background-color: #833e93;
		color: #ffffff;
		border: 1px transparent;
	}
	.survey-theme {
		color: #709F34 !important;
		padding-left: 34px;
	}
	.survey-date {
		color: #828282;
		font-size: 10px;
		text-align: right;
		float: right;
		line-height: 16px;
	}
	.survey-taken-date{
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		word-break: break-word;
	}
	.expand-holder {
		padding: 3px;
		border: 1px solid #CCCCCC;
		border-radius: 50%;
		cursor: pointer;
		width: 10px;
		height: 10px;
		padding-top: 3px;
		.el-icon-arrow-down {
			vertical-align: text-top;
			color: #666666;
		}
	}
}
.expanded .expand-holder .el-icon-arrow-down {
	transform: rotate(180deg);
}
.el-table--enable-row-hover .el-table__body tr:hover > td.questionnaire-cell.survey-cell {
	background-color: #ffffff;
}
.questionnaire-cell.survey-cell {
	cursor: default;
	background-color: #ffffff;
	&.first .cell{
		padding-left: 0;
	}
}

.el-table tr.not-yet {
	background-color: #f8f8f8;
	.questionnaire-cell.survey-cell {
		background-color: #f8f8f8;
	}
	.el-table__expand-column {
		display: none;
	}
}
.el-table tr.answered {
	background-color: #edf8df;
	.questionnaire-cell.survey-cell {
		background-color: #edf8df;
	}
}
.el-table--enable-row-hover .el-table__body tr.not-yet:hover > td.questionnaire-cell.survey-cell {
	background-color: #f8f8f8;
}
.el-table--enable-row-hover .el-table__body tr.answered:hover > td.questionnaire-cell.survey-cell {
	background-color: #edf8df;
}
.questionnaire-table table.el-table__body {
	background-color: #f8f8f8;
}
</style>

<style lang="scss" scoped>

.incomplete-section {
	display: flex;
	flex-wrap: wrap;
	.incomplete {
		z-index: 101;
		display: flex;
		flex-direction: row;
		padding-right: 10px;
		padding-left: 10px;
		border-right: 1px solid #eceef6;
		.date {
			font-size: 11px;
			color: #666666;
		}
		.incomplete-text {
			width: 82px;
			height: 15px;
			background: #DA4E4E;
			border-radius: 2px;
			font-weight: 600;
			font-size: 12px;
			line-height: 12px;
			text-transform: uppercase;
			color: #FFFFFF;
			padding: 2px 2px 2px 4px;
			display: inline;
			margin-right: 5px;
		}
		.click-to-complete-text {
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			color: #666666;
			cursor: pointer;
			display: inline-block;
		}
	}
	.incomplete:last-child {
		border-right: none;
	}
}
.scores {
	display: flex;
	flex-wrap: wrap;
	.score {
		display: flex;
		flex-direction: column;
		padding-right: 10px;
		padding-left: 10px;
		border-right: 1px solid #eceef6;
		.date {
			font-size: 11px;
			color: #666666;
			margin-top: 3px;
		}
		.value {
			font-size: 17px;
			font-weight: 700;
		}
	}
	.score:last-child {
		border-right: none;
	}
}
.up-arrow-survey {
	width: 21px;
	height: 21px;
}
.respond-again {
	background-color: #EDF8DF;
	border: 1px solid #709F34;
	font-size: 12px;
	color: #709F34;
	padding: 7px 12px;
	width: 105px;
	height: 26px;
	float: right;
}
.respond-again:hover {
	background-color: transparent;
	border: 1px solid #709F34;
	color: #709F34;
}
.survey-expanded {
	background-color: #FFF !important;
}

.req-cnt {
	font-size: 11px;
	color: #525252;
	line-height: 13px;
}
</style>
